blue.ready('altTags', 'img', item => {
	if (!item.getAttribute('alt')) {		
		item.setAttribute('alt', 'UHCU image')
	}
})